import { render, staticRenderFns } from "./job-basics-alt.vue?vue&type=template&id=17ecd9dc&scoped=true"
import script from "./job-basics-alt.vue?vue&type=script&lang=js"
export * from "./job-basics-alt.vue?vue&type=script&lang=js"
import style0 from "./job-basics-alt.vue?vue&type=style&index=0&id=17ecd9dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ecd9dc",
  null
  
)

export default component.exports